let googleIdentityScriptPromise: Promise<void> | null = null

export function loadGoogleIdentityScript(): Promise<void> {
	if (window.google?.accounts.oauth2) {
		return Promise.resolve()
	}

	if (googleIdentityScriptPromise) {
		return googleIdentityScriptPromise
	}

	const scriptPromise = new Promise<void>((resolve, reject) => {
		const script = document.createElement('script')
		script.src = 'https://accounts.google.com/gsi/client'
		script.async = true
		script.defer = true
		script.onload = () => {
			if (window.google?.accounts.oauth2) {
				resolve()
				return
			}

			reject(new Error('Google Identity Services failed to initialize.'))
		}
		script.onerror = () => reject(new Error('Unable to load Google Identity Services.'))
		document.head.appendChild(script)
	})

	googleIdentityScriptPromise = scriptPromise.catch((error: unknown) => {
		googleIdentityScriptPromise = null
		throw error
	})

	return googleIdentityScriptPromise
}
